var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',_vm._g({class:['mobile-button', _setup.active && 'active'],style:(_setup.style)},_vm.$listeners),[_vm._t("default"),(_setup.active)?_c('div',{staticClass:"preload",style:({ backgroundImage: _setup.active })}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }